import React, { useState, useEffect } from 'react';
import '../LoanDetails/LoanDetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getObligation } from '../../../common/constants/api';
import { faRupeeSign, faPaperclip } from '@fortawesome/pro-solid-svg-icons';
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons';
import { numberFormat } from '../../../common/constants/NumberFormat';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
function LoanDetailsCard(props) {
  const {
    setSteps,
    setDataView,
    setShow,
    setPopUpType,
    setPopUpText,
    setIndexVal,
    setGetShowButton
  } = props;
  const [loanData, setLoanData] = useState([]);
  useEffect(() => {
    setShow(true);
    setPopUpType('loading');
    setPopUpText('Fetching the Loan Details ...');
    let applicant = getApplicantionInfo();
    getObligation(applicant.leadId, applicant.leadApplicantId).then(res => {
      setLoanData(res);
      setShow(false);
      if (res.length > 0) setGetShowButton(true);
    });
  }, []);
  const addMoreLoan = () => {
    setSteps('showLoanDetails');
  };
  const loanDetailsView = (data, i) => {
    setDataView(data);
    setIndexVal(i);
    setSteps('showLoanDetailsView');
  };
  return (
    <React.Fragment>
      <div className="flex w-full relative m-auto mt-2 loan-bar md:p-2">
        <div className="w-6/12 text-black-400 font-bold">
          {loanData.length > 0 ? 'Your Saved Loans' : ''}
        </div>
        <div
          className="w-6/12 text-orange-600 text-right cursor-pointer"
          onClick={addMoreLoan}
        >
          <FontAwesomeIcon icon={faPlusCircle} />
          <span className="ml-1">
            {loanData.length > 0 ? 'Add more' : 'Add loan'}
          </span>
        </div>
      </div>
      {loanData.length > 0 ? (
        loanData.map((data, i) => {
          return (
            <div
              className="card_items mt-4 md:w-5/12 m-2 float-left"
              onClick={() => loanDetailsView(data, i)}
            >
              <p className="font-roboto font-normal text-sm text-green-900 py-2">
                Loan {i + 1}
              </p>
              <div
                className={`loan_cards p-2 md:5/12 text-black-400 hover:shadow-md`}
              >
                <div className="flex w-full">
                  <div className="w-6/12 text-black-400">
                    <span className="px-1 float-left">
                      {/*<img src="" alt="Loan Icon" />*/}
                    </span>
                    <span className="px-1 float-left">{data.loanType}</span>
                  </div>
                  <div className="w-6/12">
                    <div className="w-full text-grey-600 pl-8 text-sm">
                      Balance Amount
                    </div>
                    <div className="w-full text-green-1100 font-bold pl-8 text-xs">
                      <FontAwesomeIcon icon={faRupeeSign} />{' '}
                      {numberFormat(data.balanceAmount)}
                    </div>
                  </div>
                </div>
                <div className="flex w-full mt-4">
                  <div className="w-6/12">
                    <div className="w-full text-grey-600 text-sm">
                      Sanction Amount
                    </div>
                    <div className="w-full font-bold text-xs">
                      <FontAwesomeIcon icon={faRupeeSign} />{' '}
                      {numberFormat(data.sanctionAmount)}
                    </div>
                  </div>
                  <div className="w-6/12">
                    <div className="w-full text-grey-600 text-sm">
                      Current EMI
                    </div>
                    <div className="w-full font-bold text-xs">
                      <FontAwesomeIcon icon={faRupeeSign} />
                      {numberFormat(data.currentEmi)}
                    </div>
                  </div>
                </div>
                <div className="flex w-full mt-4">
                  <div className="w-6/12">
                    <div className="w-full text-grey-600 text-sm">
                      Total Tenure
                    </div>
                    <div className="w-full font-bold text-xs">
                      {' '}
                      {data.totalTenure} Months
                    </div>
                  </div>
                  <div className="w-6/12">
                    <div className="w-full text-grey-600 text-sm">
                      Balance Tenure
                    </div>
                    <div className="w-full font-bold text-xs">
                      {' '}
                      {data.balanceTenure} Months
                    </div>
                  </div>
                </div>
                <div className="flex w-full mt-4">
                  <div className="w-full text-black-400">
                    <span className="px-1 float-left text-sm">
                      Lender Type:{' '}
                    </span>
                    <span className="px-1 float-left font-bold text-sm">
                      {data.lender}
                    </span>
                  </div>
                </div>
                {data.sanctionDoc != null || data.statementDoc != null ? (
                  <div className="flex w-full mt-4">
                    <div className="w-full text-black-400 border-t-2 border-dotted border-green-0 text-green-1100 pt-4">
                      {data.sanctionDoc != null ? (
                        <div className="p-1 bg-green-50 float-left ">
                          <FontAwesomeIcon icon={faPaperclip} />
                          Loan Sanction Letter
                        </div>
                      ) : null}
                      {data.statementDoc != null ? (
                        <div className="p-1 bg-green-50 float-left ml-2">
                          <FontAwesomeIcon icon={faPaperclip} />
                          Loan Statement
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })
      ) : (
        <div className="text-black-400 text-md font-normal text-center">
          You don't have any loan. Please add existing loan details.
        </div>
      )}
    </React.Fragment>
  );
}
export default LoanDetailsCard;
